export default __webpack_public_path__ + "static/media/funtel.e48e7206.png";